import O1HD from "../../../../../engines/gameEngine";
import SuperGGLItemPrefab from "./SuperGGLItemPrefab";
import normalMode from "../../../normalMode";
import NormalGameManager from "../../../manager/NormalGameManager";
import gameConfig from "../../../../../engines/configs/gameConfig";
import LotteryCenterV2Prefab from "./LotteryCenterV2Prefab";
import utilsModel from "../../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 * 超级刮刮乐
 */
@ccclass
export default class LotterySuperGGLV2Prefab extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;
    @property({type:cc.Prefab,displayName:"超级刮刮乐预制体"})
    superGGLItemPrefab : cc.Prefab = null;
    @property({type:cc.Node})
    contentNode : cc.Node = null;
    @property({type:cc.Node,displayName:"购买按钮"})
    purchaseBtnNode : cc.Node = null;
    @property({type:cc.Node,displayName:"广告购买按钮"})
    adPurchaseBtnNode : cc.Node = null;

    private mParentScript : LotteryCenterV2Prefab;

    //一等奖
    private readonly FirstPrizeArray = [50000,1000000,5000000];
    private mFirstPrizeItemIndex : number;
    private firstHasPrizeFlag : boolean = false;
    private randomStepNum : number;//当前随机步数
    private stepCountArray : number[] = [];//步数 数组
    private currLotteryRuleArray : SuperGGLEntity[];
    private currIndex : number = 0;
    private hasOpenCount : number = 0;
    private mGameLayer : NormalGameManager;

    onLoad () {
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{ easing:cc.easing.backOut }).start();

    }

    start () {
        //设置 步数
        this.refreshGameData();
    }

    bindData( parentScript : LotteryCenterV2Prefab ){
        this.mGameLayer = NormalGameManager._instance;
        this.mParentScript = parentScript;
        if ( !this.mGameLayer.getGameData().lotteryInfo ) {
            //初始化数据
            this.mGameLayer.getGameData().lotteryInfo = { gglValidCount : 0 , hjGGLValidCount : 0 ,currGGLPurchaseCount : 0 , currGJGGLPurchaseCount:0,currSuperGGLPurchaseCount:0 ,currNewGGLPurchaseCount : 0};
            this.mGameLayer.writeGameData();
        }
    }

    private _reset(){
        this.mFirstPrizeItemIndex = null;
        this.firstHasPrizeFlag = false;
        this.randomStepNum = null;
        this.stepCountArray = [];
        this.currIndex = 0;
        this.hasOpenCount = 0;
        this.currOpenIndex = 0;
        O1HD.emit("SuperGGLItemPrefab.reset");
        O1HD.emit("ShoveItemNode.reset");
    }

    //打开下标
    private currOpenIndex : number = 0;
    /**
     *
     * @param index
     */
    canTouch( index :number ) : boolean {
        console.log( "index" , index );
        if ( index != this.currOpenIndex ) {
             return false;
        }
        return true;
    }
    //更新步骤状态
    updateStepStatus( ){
        this.currOpenIndex ++;
    }


    /**
     *
     */
    refreshGameData(){
        this._reset();
        //赋值一个重新的开奖的规则
        this.currLotteryRuleArray = Object.assign( this.lotteryRuleArray );
        // 刷新设置随机步数
        let randomFirstNum = Math.floor( Math.random() * 10000 );
        if ( randomFirstNum < 1 ){
            //一等奖中奖
            this.firstHasPrizeFlag = true;
        }

        //设置一个随机一等奖
        let randomIndex = Math.floor( Math.random() * 3 );
        let randomPrize = this.FirstPrizeArray[randomIndex];
        this.mFirstPrizeItemIndex = Math.floor( Math.random() * 15 ) + 1;//一等奖 不出现在最后一栏，方便特殊 开奖情况校准（ 1 - 15 ）
        O1HD.emit("SuperGGLItemPrefab.setPrize" , this.mFirstPrizeItemIndex , randomPrize );

        //设置随机步数
        this.setRandomStepCount();
    }


    //设置随机步数
    setRandomStepCount(){
        this.randomStepNum = Math.floor( Math.random() * 14 ) + 3;
        let randomNum = this.randomStepNum;
        randomNum -= 3;
        for ( let i = 0 ; i < 3 ; i ++ ) {
            let randomTempNum = Math.floor( Math.random() * randomNum );
            //随机值
            this.stepCountArray[i] = randomTempNum+1;
            if ( this.firstHasPrizeFlag ) {
                //如果 一等奖中奖了
                if ( i == 0 && this.mFirstPrizeItemIndex < this.stepCountArray[0] ) {
                    this.stepCountArray[0] = this.mFirstPrizeItemIndex;
                }else if ( i == 1 && this.mFirstPrizeItemIndex < this.stepCountArray[0] + this.stepCountArray[1] ){
                    this.stepCountArray[1] = this.mFirstPrizeItemIndex - this.stepCountArray[0];
                }else if ( i == 2 && this.mFirstPrizeItemIndex < this.stepCountArray[0] + this.stepCountArray[1] + this.stepCountArray[2] ){
                    this.stepCountArray[2] = this.mFirstPrizeItemIndex - this.stepCountArray[0] - this.stepCountArray[1];
                }else{
                    this.stepCountArray[2] = this.mFirstPrizeItemIndex - this.stepCountArray[0] - this.stepCountArray[1];
                }
            }else{
                //如果一等奖 未中奖
                if ( i == 0 && this.stepCountArray[0] == this.mFirstPrizeItemIndex ) {
                    //第一个步数  与一等奖 重合
                    if ( this.mFirstPrizeItemIndex == 1 ) {
                        this.stepCountArray[0] = 2
                        randomTempNum++;
                    }else{
                        this.stepCountArray[0]--;
                        randomTempNum--;
                    }
                }else if ( i == 1 && (this.stepCountArray[0] + this.stepCountArray[1]) == this.mFirstPrizeItemIndex ){
                    //第二个步数  与一等奖 重合
                    if ( this.stepCountArray[1] == 1 ) {
                        this.stepCountArray[1] ++;
                        randomTempNum++;
                    }else{
                        this.stepCountArray[1]--;
                        randomTempNum--;
                    }
                }else if ( i == 2 && (this.stepCountArray[0] + this.stepCountArray[1] + this.stepCountArray[2] ) == this.mFirstPrizeItemIndex) {
                    //第三个步数  与一等奖 重合
                    if ( this.stepCountArray[2] == 1 ) {
                        this.stepCountArray[2] ++;
                        randomTempNum++;
                    }else{
                        this.stepCountArray[2]--;
                        randomTempNum--;
                    }
                }
            }
            randomNum -= randomTempNum;
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            this.mParentScript && this.mParentScript.refreshBtn();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

    /**
     * 获取当前奖项
     */
    getPrize(  ) : number{
        let retPrize : number;
        //获取总权重
        let allWeight : number = 0;
        for ( let itemData of this.currLotteryRuleArray ) {
            allWeight += itemData.weight;
        }

        //开奖权重
        let randomWeight = Math.floor( Math.random() * allWeight );

        for ( let i = 0 ; i < this.currLotteryRuleArray.length ; i ++ ) {
            if ( randomWeight <= this.currLotteryRuleArray[i].weight ) {
                retPrize = this.currLotteryRuleArray[i].prize;
                if ( this.currLotteryRuleArray[i].uniqueId == "三等奖" || this.currLotteryRuleArray[i].uniqueId == "二等奖" ) {
                    this.currLotteryRuleArray.splice( i , 1 );
                }
                break;
            }
            randomWeight -= this.currLotteryRuleArray[i].weight;
        }
        return retPrize ;
    }



    /**
     * 开奖
     * @param prize
     * @param node
     */
    openPrize( prize : number , node : cc.Node ){
        if ( prize != 0 ) {
            O1HD.getServices().userSrv.setCoins( prize , true , node );
        }
    }

    /**
     * 获取当前步数
     */
    getStepNum( index : number ){
        return this.stepCountArray[index];
    }


    /**
     * 刮开了步数
     * @param index
     */
    openStepNum( stepCount : number ){
        let tempCurrIndex = this.currIndex;
        //设置当前位置
        this.currIndex += stepCount;
        // 播放行径动画
        for ( let i = 1 ; i <= stepCount ; i ++ ) {
            this.scheduleOnce(()=>{
                O1HD.emit("SuperGGLItemPrefab.setLight" , tempCurrIndex + i , i != stepCount ? false : true );
            },0.5 * i );
            //如果等于
            if ( i == stepCount ) {
                this.scheduleOnce(()=>{
                    this.hasOpenCount ++;
                    if ( this.hasOpenCount == 3 ) {
                        this._refreshBtn();
                    }
                },0.5 * (i + 2) );
            }
        }
    }

    /**
     * 完成步骤
     */
    finishStepNum(){

    }

    /**
     * 购买
     */
    onBtnPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( O1HD.getServices().userSrv.getCoins() < 20 ) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins(-20,true );
        this.mGameLayer.getGameData().lotteryInfo.currSuperGGLPurchaseCount ++;
        this.mGameLayer.writeGameData();
        this.purchaseBtnNode.active = false;
        this.adPurchaseBtnNode.active = false;
        this.refreshGameData();
    }

    /**
     * 广告购买
     */
    onBtnAdPurchase(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.purchaseBtnNode.active = false;
            this.adPurchaseBtnNode.active = false;
            this.refreshGameData();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"彩票解锁");
    }

    private _refreshBtn(){
        let lotteryInfo = this.mGameLayer.getGameData().lotteryInfo;
        if ( lotteryInfo.currSuperGGLPurchaseCount >= gameConfig.SUPER_GGL_CURR_LIMIT ) {
            // 显示看视频购买按钮
            this.adPurchaseBtnNode.active = true;
        }else{
            this.purchaseBtnNode.active = true;
        }
    }

    private readonly lotteryRuleArray : SuperGGLEntity[] = [
        {
            uniqueId :"谢谢惠顾",
            prize : 0 ,
            weight : 7000,
        },
        {
            uniqueId :"鼓励奖",
            prize : 5 ,
            weight : 2800,
        },
        {
            uniqueId :"三等奖",
            prize : 200,
            weight : 1090,
        },
        {
            uniqueId :"二等奖",
            prize : 8888,
            weight : 109,
        }
    ];
}


export interface SuperGGLEntity{
    uniqueId : string;
    prize : number ,
    weight : number
}
